{
  "page": {
    "title": "ทีม"
  },
  "members": {
    "title": "สมาชิกทีม",
    "empty": "ยังไม่มีสมาชิก",
    "owner": "เจ้าของ",
    "admin": "แอดมิน",
    "unknown": "ไม่ระบุ",
    "thisMember": "สมาชิกนี้",
    "extraPermissions": "สิทธิ์เพิ่ม {{count}}",
    "managePermissions": "จัดการสิทธิ์",
    "remove": "ลบออก",
    "removeTitle": "ลบสมาชิกออกจากทีม",
    "removeDetail": "ต้องการลบ {{name}} ออกจากทีมหรือไม่? สมาชิกจะไม่สามารถเข้าถึงร้านค้านี้ได้อีก แต่สามารถเชิญกลับเข้าทีมใหม่ได้ภายหลัง",
    "removeButton": "ลบสมาชิก",
    "removeSuccess": "ลบสมาชิกสำเร็จ",
    "removeFailed": "ลบสมาชิกไม่สำเร็จ",
    "cancel": "ยกเลิก"
  },
  "invitations": {
    "title": "คำเชิญ",
    "pending": "รอตอบรับ",
    "accepted": "ยอมรับแล้ว",
    "revoked": "ยกเลิกแล้ว",
    "expired": "หมดอายุ",
    "sendSuccess": "ส่งคำเชิญสำเร็จ",
    "sendFailed": "ส่งคำเชิญไม่สำเร็จ",
    "revokeSuccess": "ยกเลิกคำเชิญสำเร็จ",
    "revokeFailed": "ยกเลิกคำเชิญไม่สำเร็จ",
    "copied": "คัดลอกลิงก์แล้ว",
    "copyFailed": "ไม่สามารถคัดลอกลิงก์ได้ กรุณาคัดลอกด้วยตนเอง",
    "planExpired": "แพ็กเกจหมดอายุ กรุณาสมัครแพ็กเกจก่อน",
    "seatsFull": "ที่นั่งของแพ็กเกจเต็มแล้ว",
    "seatsUsed": "ใช้ที่นั่ง {{used}} / {{total}}",
    "addSeats": "เพิ่มที่นั่ง",
    "inviteAdmin": "เชิญแอดมิน",
    "empty": "ยังไม่มีคำเชิญที่รอดำเนินการ",
    "copyLink": "คัดลอกลิงก์",
    "cancel": "ยกเลิก",
    "send": "ส่งคำเชิญ",
    "email": "อีเมล"
  },
  "permissions": {
    "title": "จัดการสิทธิ์ของ {{name}}",
    "member": "สมาชิก",
    "close": "ปิด",
    "roleBase": "ติดมากับบทบาท Admin",
    "updateFailed": "อัปเดตสิทธิ์ไม่สำเร็จ",
    "manageProducts": {
      "label": "จัดการสินค้า",
      "description": "เพิ่ม แก้ไข ลบสินค้าและสต็อก"
    },
    "manageOrders": {
      "label": "จัดการออเดอร์",
      "description": "ดูและอัปเดตสถานะออเดอร์ของลูกค้า"
    },
    "connectPlatform": {
      "label": "เชื่อมต่อช่องทาง",
      "description": "เชื่อม LINE / Facebook / Instagram และตั้งค่าช่องทาง"
    },
    "inviteAdmin": {
      "label": "เชิญและจัดการแอดมิน",
      "description": "เชิญสมาชิกใหม่ ยกเลิกคำเชิญ และตั้งค่าสิทธิ์ของแอดมินคนอื่น"
    },
    "manageBilling": {
      "label": "ดูแพ็กเกจและจัดการการชำระเงิน",
      "description": "เห็นหน้าแพ็กเกจ สั่งซื้อแพ็กเกจ และดูประวัติการชำระเงิน"
    },
    "manageAiBot": {
      "label": "ตั้งค่าผู้ช่วย AI",
      "description": "เปิด/ปิดบอท ตั้งค่าข้อความ ช่องทาง และการชำระเงินของผู้ช่วย AI"
    }
  },
  "invitePage": {
    "emailMismatch": "อีเมลของคุณไม่ตรงกับคำเชิญ",
    "userHasMerchant": "คุณมีร้านค้าอยู่แล้ว ไม่สามารถรับคำเชิญได้",
    "notFound": "คำเชิญไม่พบหรือหมดอายุแล้ว",
    "genericError": "เกิดข้อผิดพลาด กรุณาลองใหม่",
    "success": "เข้าร่วมทีมสำเร็จ!",
    "invited": "คุณได้รับคำเชิญ",
    "signInPrompt": "เข้าสู่ระบบหรือลงทะเบียนด้วยอีเมลที่ได้รับคำเชิญ",
    "joinTeamPrompt": "เพื่อเข้าร่วมทีม",
    "login": "เข้าสู่ระบบ",
    "register": "ลงทะเบียน",
    "redirecting": "กำลังพาคุณไปที่แดชบอร์ด...",
    "joinMerchant": "เข้าร่วม {{name}}",
    "team": "ทีม",
    "acceptTitle": "รับคำเชิญ",
    "invitedBy": "{{name}} ได้เชิญคุณเป็น {{role}}",
    "admin": "แอดมิน",
    "joinInvitation": "คุณได้รับคำเชิญให้เข้าร่วมทีม",
    "accept": "ยอมรับคำเชิญ"
  },
  "errors": {
    "selfInvite": "ไม่สามารถเชิญตนเองได้",
    "teamFull": "ทีมเต็มแล้ว",
    "seatCap": "ที่นั่งของแพ็กเกจเต็มแล้ว กรุณาอัปเกรดแพ็กเกจหรือเพิ่มที่นั่ง",
    "subscriptionExpired": "แพ็กเกจหมดอายุ กรุณาสมัครแพ็กเกจก่อนเชิญสมาชิก",
    "tooManyPending": "มีคำเชิญที่รอดำเนินการมากเกินไป",
    "duplicate": "ส่งคำเชิญไปยังอีเมลนี้แล้ว",
    "userHasMerchant": "ผู้ใช้นี้มีร้านค้าอยู่แล้ว",
    "cooldown": "กรุณารอสักครู่ก่อนส่งคำเชิญอีกครั้ง",
    "generic": "เกิดข้อผิดพลาด กรุณาลองใหม่"
  }
}
